// extracted by mini-css-extract-plugin
export default {"multiChipInput":"MultiChipTextField__multiChipInput___Zy5XR"};